import { render } from "./expiredIndexComponent.vue?vue&type=template&id=888a2bbe"
import script from "./expiredIndexComponent.vue?vue&type=script&lang=js"
export * from "./expiredIndexComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__